import MemoList from "../MemoList";

export default function PamSec() {
  return <MemoList memoType="Pam-sec" />;
}
